import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeaderZaptrance from './HeaderZaptrance';
import ZaptranceSideNav from './ZaptranceSideNav';
import axios from 'axios';

import AddUserModal from './modals/AddUserModal';
import PeopleIcon from '@mui/icons-material/People';

import FilterIcon from '@mui/icons-material/FilterListOutlined';
import EditIcon from '@mui/icons-material/ModeOutlined';

import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';


const ZaptrancePrograms = () => {
  const navigate = useNavigate();
    
  
  const [users, setUsers] = useState([]);
  const [institutions, setInstitutions] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedUser, setSelectedUser] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(users ? users.length : 0);

   //sorting
   const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
   const [sortColumn, setSortColumn] = useState('fullname'); // Default column to sort
   //sorting
  

   const [isUpdateLoading, setIsUpdateLoading] = useState(false);
   const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
   const [errorMessage, setErrorMessage] = useState('');
   const [registrationStatus, setRegistrationStatus] = useState(null);


  const openAddModal = () => {
    setIsAddModalOpen(true);
  };

  const closeAddModal = () => {
    setIsAddModalOpen(false);
  };

  const handleAddUser = (userName) => {
    closeAddModal();
  };


  const [searchQuery, setSearchQuery] = useState('');
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  // const filteredUsers = users.filter((user) =>
  // user.fullName.toLowerCase().includes(searchQuery.toLowerCase()) ||
  // user.institution.toLowerCase().includes(searchQuery.toLowerCase())
  // );
  let filteredUsers;
try {
  filteredUsers = users.filter((user) =>
    (user.fullName && user.fullName.toLowerCase().includes(searchQuery.toLowerCase())) ||
    (user.institution && user.institution.toLowerCase().includes(searchQuery.toLowerCase()))
  );
} catch (error) {
  // Handle the exception here, such as logging the error or providing a default value
  console.error("An error occurred while filtering users:", error);
  // Set filteredUsers to an empty array or any default value as needed
  filteredUsers = [];
}

// Now filteredUsers will contain the filtered user data, or an empty array if an exception occurred



  


  let token = localStorage.getItem('token');
  useEffect(() => {
    if (!token) {
      navigate('/');
    } else {
      handleData();
    }
  }, [navigate]);
  

  const handleRowClick = (user, e) => {
    
    //alert(JSON.stringify(user, null, 2));
    //alert(registration.id);

    setSelectedRow(user);
    setSelectedUser(user);
    
    //alert(institution.name);

    //alert(programTypes);
    //alert(JSON.stringify(programTypes, null, 2));
    //return;
    
    // setIsAddProgramModalOpen(true);
    // navigate(`/zaptrance-institution-detail/${institution}`);

    const userString = JSON.stringify(user);
    const additionalVariable = 'noEdit';
    navigate(`/zaptrance-users/${encodeURIComponent(userString)}/${additionalVariable}`);

  };



  const handleData = async () => { 
    try {
      const response = await axios.get('https://gacsstage.zaptrance.ng/api/admin/users', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        //alert(JSON.stringify(response.data.data, null, 2));

        //alert("Auwal respond with the INSTITUTION_ID, as well as the USER_TYPE_ID in this list. I'll need it to update the user status.");

        setUsers(response.data.data);
        setTotalItems(response.data.data.length);
        setLoading(false); 

        await getInstitutions();
      } else {
        alert('Request failed:' + response.data.message);
      }
    } catch (error) {
      alert('Request error:'+ error);
    }
  };

  const handleEditOnClick = (user, e) => {
    e.stopPropagation();
    //alert(JSON.stringify(institution, null, 2));
    //alert(registration.id);

    setSelectedRow(user);
    setSelectedUser(user);
    
    //alert(institution.name);

    //alert(programTypes);
    //alert(JSON.stringify(programTypes, null, 2));
    //return;
    
    // setIsAddProgramModalOpen(true);
    // navigate(`/zaptrance-institution-detail/${institution}`);

    const userString = JSON.stringify(user);
    // Navigate to the detail page with the serialized institution as a parameter
    const additionalVariable = 'edit';
    //navigate(`/zaptrance-institution-detail/${encodeURIComponent(institutionString)}`);
    navigate(`/zaptrance-users/${encodeURIComponent(userString)}/${additionalVariable}`);

  };


  const getInstitutions = async () => { 
    try {
      const response = await axios.get('https://gacsstage.zaptrance.ng/api/admin/institutions', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.data.success) {
        setInstitutions(response.data.data);
        setLoading(false); 
      } else {
        console.error('Request failed:' + response.data.message);
      }
    } catch (error) {
      console.error('Request error:'+ error);
    }
  };



  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFilteredUsers = filteredUsers ? filteredUsers.slice(indexOfFirstItem, indexOfLastItem) : [];
  let countUsers = indexOfFirstItem + 1;



  // const handleSort = (column) => {
  //   const order = sortOrder === 'asc' ? 'desc' : 'asc';
  //   setSortColumn(column);
  //   setSortOrder(order);
  
  //   // Create a copy of the users array and sort it
  //   if (column == "fullname" || column == "institution" || column == "email" || column == "type" || column == "status") {
  //     const sortedUsers = [...currentFilteredUsers].sort((a, b) => {
  //       const valueA = a[column].toLowerCase();
  //       const valueB = b[column].toLowerCase();
    
  //       if (valueA < valueB) return order === 'asc' ? -1 : 1;
  //       if (valueA > valueB) return order === 'asc' ? 1 : -1;
  //       return 0;
  //     });
    
  //     setInstitutions(sortedUsers);
  //   } 
    
  // };

  const handleChangeDataClick = (user, e) => {
    e.stopPropagation();

    //alert("@auwal provide update user status endpoint\n\n" + JSON.stringify(user, null, 2));

    //let option = institution.status === 'active' ? 'inactive' : 'active' ;
    if (!isUpdateLoading) {
      handleChangeStatus(user);
    } else {
      alert("Please wait");
    }
    
  };

  
  const handleChangeStatus = async (user) => { 

    let userTypeId = "";
    if (user.type == 'zaptrance' ){ userTypeId ="1";}
        else if (user.type == 'nbte' ){userTypeId ="2";}
        else if (user.type == 'rector' ){userTypeId = "3";}
        else if (user.type == 'registrar' ){userTypeId = "4";}
        else if (user.type == 'admin' ){userTypeId = "5";}
        else {userTypeId = "0";}

        let userStatus = "";
        if (user.status == "active") { userStatus = "inactive";}
        if (user.status == "inactive") { userStatus = "active";}

    // alert(
    //   "fullname: " + user.fullname + "\n" + 
    //   "institutionId: " + user.institution_info.id + "\n" + // cIuserInstitutionId, //'@Auwal provide this in /admin/users response' + "\n" + 
    //   "institution: " + user.institution_info.name + "\n" + 
    //   "email: " + user.email + "\n" + 
    //   "usertypeId: " + userTypeId + "\n" +//'@Auwal provide this in /admin/users response'  + "\n" + 
    //   "usertype: " + user.type  + "\n" + 
    //   "status: " + userStatus
    // );


    const formData = new FormData();
    formData.append('userId', user.id);
    formData.append('fullName', user.fullname);
    formData.append('institution', user.institution_info.id);
    //formData.append('email', value4);
    formData.append('type', userTypeId);
    formData.append('status', userStatus);
    

    setIsUpdateLoading(true);
    try {
      // alert(`here: ${params.id}`);
      //console.log(value1, formData)
      const response = await axios.patch(`https://gacsstage.zaptrance.ng/api/admin/users/${user.id}`, formData, {
        headers: {
          'Content-Type': 'application/json', //'Content-Type': 'multipart/form-data', // Use multipart/form-data for file uploads
          Authorization: `Bearer ${token}`,
        },
      });

      setIsUpdateLoading(false);
      if (response.data.success) {
        //alert("user update status: " + JSON.stringify(response.data.data, null, 2));
        await handleData();

      } else {
        // Handle the case where the request was not successful
        alert('Request failed:' + response.data.message);
      }
    } catch (error) {
      setIsUpdateLoading(false);
      alert('Request error:'+ error);
      // Handle request error, e.g., display an error message to the user
    }


  };


  return (
    <div className="content flex-grow">
        <div className="inner-content">
          <HeaderZaptrance />
          <div className=' p-4' style={{ backgroundColor: '#F6F7FB' }}>
          <div className='text-black p-4 flex text-xl'>
                            <div><PeopleIcon className='mr-4'/></div>Users
                        </div>

            <div className="text-right">
            <button className="px-6 py-3 m-4" 
            style={{ 
              width: '200px', 
              backgroundColor: '#095918', 
              borderRadius: '8px', 
              padding: '10px 20px', 
              color: 'white', 
              border: 'none', 
              }}
              onClick={openAddModal}
              >
              Add Users
              </button>
            </div>

            {loading ? (
              <div className='p-4'>Loading...</div>
            ) : (
<div>
  
<div className="flex justify-between my-2 pb-2 ">
  <div className="flex items-center">
    <div className="text-xl">Users List</div>
  </div>
  <div className="flex items-center">
    <input
      type="text"
      placeholder="Search"
      className="border border-gray-300 rounded-lg py-1 px-2 mr-4"
      onChange={handleSearchChange}
    />
    <div className="flex items-center">
      <FilterIcon className="text-gray-500 cursor-pointer" />
      <span className="text-gray-500 ml-1">Filter Search</span>
    </div>
  </div>
</div>


              <div className='overflow-x-auto'>
                <table className='min-w-full bg-white shadow-md rounded-lg overflow-hidden'>
                  {/* Table Header */}
                  <thead>
                    <tr>
                      <th style={{backgroundColor: '#095918'}} className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        S/N
                      </th>
                      <th style={{backgroundColor: '#095918'}} 
                      //onClick={() => handleSort('fullname')}
                      className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Full Name
                        {/* {sortColumn === 'fullname' && (
                          <span className='pl-2' style={{ cursor: "pointer" }}>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                          )} */}
                      </th>
                      <th style={{backgroundColor: '#095918'}} 
                      //onClick={() => handleSort('institution')}
                      className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Institution
                        {/* {sortColumn === 'institution' && (
                          <span className='pl-2' style={{ cursor: "pointer" }}>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                          )} */}
                      </th>
                      <th style={{backgroundColor: '#095918'}} 
                      //onClick={() => handleSort('email')}
                      className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Email
                        {/* {sortColumn === 'email' && (
                          <span className='pl-2' style={{ cursor: "pointer" }}>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                           )} */}
                      </th>
                      <th style={{backgroundColor: '#095918'}} 
                      //onClick={() => handleSort('type')}
                      className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Type
                        {/* {sortColumn === 'type' && (
                          <span className='pl-2' style={{ cursor: "pointer" }}>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                          )} */}
                      </th>
                      <th style={{backgroundColor: '#095918'}} className="px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider">
                        Action
                      </th>
                      <th style={{backgroundColor: '#095918'}} 
                      //onClick={() => handleSort('status')}
                      className='px-6 py-3 border-b border-gray-300 text-left text-xs leading-4 font-medium text-white uppercase tracking-wider'>
                        Status
                        {/* {sortColumn === 'status' && (
                          <span className='pl-2' style={{ cursor: "pointer" }}>{sortOrder === 'asc' ? ' ▲' : ' ▼'}</span>
                          )} */}
                      </th>
                    </tr>
                  </thead>
                  {/* Table Body */}
                  <tbody>
                    {currentFilteredUsers .map((user) => (
                      <tr key={user.id} onClick={(e) => handleRowClick(user, e)} style={{ cursor: "pointer" }}>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                        {countUsers++} {/* {user.id} */}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {user.fullName}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {user.institution}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {user.email}
                        </td>
                        <td className='px-6 py-4 whitespace-no-wrap border-b border-gray-200'>
                          {user.type}
                        </td>
                        
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200">
                          <span className="mr-4" style={{ color: 'green' }} onClick={(e) => handleEditOnClick(user, e)} ><EditIcon /></span>
                          <span className="mr-4" style={{ color:  user.status === 'active' ? 'green' : 'red' }} onClick={(e) => handleChangeDataClick(user, e)} >{ user.status === 'active' ? <ToggleOnIcon /> : <ToggleOffIcon />}</span>
                          <span className="" style={{ color: 'green' }}>More</span>
                          
                        </td>
                        <td className="px-6 py-4 whitespace-no-wrap border-b border-gray-200 " >
                          <div className="text-center px-2 py-1" style={{ 
                            borderRadius: '10px', 
                            color: user.status === 'active' ? 'green' : 'red',
                            background: '#eeeeee' }}>{user.status}
                            </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
</div>
            )}

           {/* Pagination Controls */}
      <div className="flex justify-center mt-4">
        <button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          className="px-4 py-2 mr-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
          style={{width: '100px', borderRadius: '30px',}}
        >
          Previous
        </button>
        <button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage)))}
          disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}
          className="px-4 py-2 bg-gray-300 hover:bg-nbteGreen hover:text-white transition-colors duration-300"
          style={{width: '100px', borderRadius: '30px',}}
        >
          Next
        </button>
      </div>



<AddUserModal
              isOpen={isAddModalOpen}
              onRequestClose={closeAddModal}
              onAddUser={handleAddUser}
              institutions={institutions}
              
            />

          </div>
        </div>
      </div>
  );
};

export default ZaptrancePrograms;
